import { render } from "./stats.template.html?vue&type=template&id=237cbe6b&scoped=true"
import script from "./Stats.vue?vue&type=script&lang=ts"
export * from "./Stats.vue?vue&type=script&lang=ts"

import "./Stats.vue?vue&type=style&index=0&id=237cbe6b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-237cbe6b"

export default script